<template>
  <span>© 2025</span>
  <span>北京星汉未来网络科技有限公司</span>
  <span>
    <a-button type="link" target="_blank"
              :href="href.record">
      版权所有<i class="emblem" />京ICP备2021024542号-3
    </a-button>
  </span>
  <span>
    <a-button type="link" target="_blank"
              :href="href.recordWeb">
      京公网安备 11010802035850号
    </a-button>
  </span>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'footer',
  data(): DataInterface {
    return {
      href: {
        record: 'https://beian.miit.gov.cn',
        recordWeb: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802035850'
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

span {
  margin: 0 15px 0 0;
  .font(justify-all, 16px, @color_3, 14px);
  
  &:last-child {
    margin: 0;
  }
  
  a {
    height: auto;
    padding: 0;
    .font(justify-all, 16px, @color_3, 14px);
    .transition(opacity @time);
    
    &:hover {
      opacity: @opacity;
    }
  }
}

.emblem {
  display: inline-block;
  margin: 0 5px 0 15px;
  .bg('@{src_image}public/icon_record.png', 9px, 10px, true);
  .transform(translateY(0.5px) scale(1.5));
}

&:deep(.ant-btn) {
  color: @color_3;
}
</style>